import apiClient from "./api-client.service";
import { Judge0Status, ProgrammingLanguage } from "../Interface/Index";

class CodeService {
  async getAllLangugaes(): Promise<ProgrammingLanguage[]> {
    try {
      const response = await apiClient.get("/coding/languages");
      return response.data;
    } catch (error: any) {
      console.error("CodeService -> getAllLangugaes -> error", error);
      return [];
    }
  }

  async getStatuses(): Promise<Judge0Status[]> {
    try {
      const response = await apiClient.get(`coding/statuses`);
      return response?.data || [];
    } catch (error: any) {
      console.error("CodeService -> getStatuses -> error", error);
      return [];
    }
  }

  async compileCode(
    sourceCode: string,
    languageId: number
  ): Promise<string | null> {
    try {
      const response = await apiClient.post("/coding/compile", {
        sourceCode,
        languageId,
      });

      return response.data;
    } catch (error: any) {
      console.error("CodeService -> compileCode -> error", error);
      return null;
    }
  }
}

const codeService = new CodeService();
export default codeService;
